import { createAction } from "@reduxjs/toolkit";

export const SET_IS_OLD_APP_VERSION = createAction(
  "version/SET_IS_OLD_APP_VERSION"
);
